import {
  ENGLISH_LOCALE,
  JAPANESE_LOCALE,
  LOCALE_OPTIONS
} from '@link/share/constants';
import i18n, { initI18n, setLocale, getLocaleValues } from '@link/share/i18n';
import en from './lang/en';
import ko from './lang/ko';
import zh from './lang/zh';
import zt from './lang/zt';

// Shinkansen does not support Japanese locale, and default to English
export const DEFAULT_LOCALE = ENGLISH_LOCALE;
export const SUPPORTED_LOCALE_OPTIONS = LOCALE_OPTIONS.filter(
  locale => locale.value !== JAPANESE_LOCALE
);
export const SUPPORTED_LOCALE_LIST = getLocaleValues(SUPPORTED_LOCALE_OPTIONS);

initI18n({
  // Shinkansen does not support Japanese locale, so we don't need to provide Japanese translations
  // jaText: ja,
  enText: en,
  koText: ko,
  zhText: zh,
  ztText: zt,
  defaultLocale: DEFAULT_LOCALE,
  supportedLocales: SUPPORTED_LOCALE_LIST
});

export { setLocale };

export default i18n;
